
import OptionGroupView from '@/components/OptionGroupView.vue';
import { AdditionalOptionsPathSegment } from '@/models/additional-options-path-segment';
import he from 'he';
import { computed, ComputedRef, defineComponent, PropType } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
  name: 'AdditionalOptionsPathSegmentView',
  components: {OptionGroupView},
  props: {
    segment: {
      type: Object as PropType<AdditionalOptionsPathSegment>,
      required: true,
      default: null
    }
  },
  setup() {
    const store = useStore();

    /**
     * Returns the number of chosen columns for larger desktops
     */
    const columns: ComputedRef<number> = computed(() => {
      return store.state.morticianSettings?.columns ?? '';
    });

    const columnsNoGutter: ComputedRef<boolean> = computed(() => {
      return store.state.morticianSettings?.columnsNoGutter ?? '';
    });

    function decodeHtml(input: string): string {
      return he.decode(input);
    }

    return {
      decodeHtml,
      columns,
      columnsNoGutter
    };
  }
});
